import { render, staticRenderFns } from "./infoCardWithImage.vue?vue&type=template&id=4ca8c5e7&"
import script from "./infoCardWithImage.vue?vue&type=script&lang=js&"
export * from "./infoCardWithImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports